import React from "react";

function PrintIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="28.017"
      viewBox="0 0 30 28.017"
      {...props}
    >
      <path
        id="printer-icon"
        d="M4.507,21.94h-2.6a1.9,1.9,0,0,1-1.348-.559L.5,21.318a1.909,1.909,0,0,1-.5-1.3V8.653A1.907,1.907,0,0,1,.562,7.3l.061-.056a1.9,1.9,0,0,1,1.287-.5H4.915a1.97,1.97,0,0,1-.032-.361V1.987a1.965,1.965,0,0,1,.584-1.4h0A1.97,1.97,0,0,1,6.861,0H23.142a1.985,1.985,0,0,1,1.98,1.98V6.375a1.97,1.97,0,0,1-.034.361h3.006a1.907,1.907,0,0,1,1.345.559h0A1.9,1.9,0,0,1,30,8.643V20.021a1.914,1.914,0,0,1-1.909,1.909H25.5v4.959a1.13,1.13,0,0,1-.332.8,1.055,1.055,0,0,1-.1.083,1.123,1.123,0,0,1-.706.244H5.64a1.13,1.13,0,0,1-.8-.332.747.747,0,0,1-.083-.1,1.123,1.123,0,0,1-.244-.706V21.94Zm2.085-15.2H23.417l.046-.042a.454.454,0,0,0,.134-.32V1.987a.459.459,0,0,0-.457-.457H6.861a.457.457,0,0,0-.322.134h0a.457.457,0,0,0-.132.322V6.382a.449.449,0,0,0,.134.32l.046.042ZM8.863,24.252a.586.586,0,1,1,0-1.172h6.675a.586.586,0,0,1,0,1.172Zm0-3.555a.586.586,0,1,1,0-1.172H21.147a.586.586,0,0,1,0,1.172ZM1.726,14.8h26.55V8.653a.186.186,0,0,0-.054-.132.188.188,0,0,0-.129-.054H1.909a.186.186,0,0,0-.112.039l-.017.017a.186.186,0,0,0-.054.129Zm26.55,1.726H24.951a1.008,1.008,0,0,1,.212.168,1.13,1.13,0,0,1,.332.8v2.72h2.6a.183.183,0,0,0,.129-.054.193.193,0,0,0,.054-.129V16.525Zm-23.225,0H1.726v3.5a.2.2,0,0,0,.037.112l.017.017a.183.183,0,0,0,.129.054h2.6v-2.71a1.13,1.13,0,0,1,.332-.8,1.008,1.008,0,0,1,.212-.168Zm18.72,1.033H6.231v8.748h17.54V17.558Z"
        transform="translate(0 0)"
        fill="#2d6289"
      />
    </svg>
  );
}

export default PrintIcon;
